import React, { useState, useEffect} from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Sidebar from '../layout/Sidebar';
import projectedit from '../../images/projectdetails/projectedit.png';
import broadcast from '../../images/project/broadcast.png';
import projectclone from '../../images/projectdetails/clone.png';
import '../../scss/projectdetails.scss';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import ProjectInfo from '../Reusables/ProjectInfo';
import getResponse from '../actions/Project';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseCloneProject } from '../../store/Actions';
import Spinner from '../Reusables/Spinner';
import parse from 'html-react-parser';
import Descriptor from '../Reusables/Descriptor';
import Calender from '../Reusables/Calender';
import Dropdown from '../Reusables/Dropdown';
import MultiSelectionDropdown from '../Reusables/MultiSelectionDropdown';
import Cookies from 'js-cookie'
import RefreshToken from '../actions/RefreshToken';
import getResponseEntity from '../actions/Entity.js';
import EditProjectConfirm from '../popups/EditprojectConfirm';
import Snackbars from '../Reusables/Snackbar';
import Tooltip from "@material-ui/core/Tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { trim } from '../Reusables/Function';
import { convertToDateString } from '../Reusables/Function';
import restore from '../../images/project/restore-blue.png';
import DeleteItem from '../popups/DeleteItem';

function PageDetails(props) {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [complete, setComplete] = useState(false);
    const [projectDetails, setProjectDetails] = useState([]);
    const [deleteform, setDeleteForm] = useState();
    const [deletefile, setDeleteFile] = useState();
    const [deletetask, setDeleteTask] = useState();
    const [uploadstate, setUpload] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [projectname, setProjectname] = useState(null);
    const [entityid, setEntityId] = useState([]);
    const [startdate, setStartdate] = useState(false);
    const [date, setDate] = useState(null);
    const [label, setLabel] = useState('Select Date');
    const [resend, setResend] = useState({
        date: null,
        startDate: false,
        label: 'Select Date',
      });
      
    const [adestraReport, setAdestraReport] = useState(null);
    const [adestraReportResend, setAdestraReportResend] = useState(null);
    const [description, setDescription] = useState(null);
    const [entityList, setEntityList] = useState([]);
    const [entityLabel, setEntityLabel] = useState('Select Property');
    const [toggle, setToggle] = useState(true);
    const [editerror, setEditerror] = useState('');
    const accesstoken =  Cookies.get('access_token');
    const [showTasks, setShowTasks] = useState(false)
    const [open, setOpen] = useState(null)
    const [tooltipMessage, setTooltipMessage] = useState("Copy Link")
    const [projectTypeLabel, setprojectTypeLabel] = useState('Select Project Type');
    const [projectTypeId, setProjectTypeId] = useState(null);
    const [projectTypeList, setProjectTypeList] = useState([]);
    const [projectTypeEnable, setProjectTypeEnable] = useState(null);
    const [currentprojectType, setCurrentProjectType] = useState(null);
    const[currentBrand, setCurrentBrand] = useState(null);
    const [brandId, setBrandId] = useState(0);
    const [confirmButtonEnable, setConfirmButtonEnable] = useState(true);
    const [showeditconfirm, setShoweditconfirm] = useState(false);
    const handleConfirmHide = () => setShoweditconfirm(false);
    const [entityName, setEntityName] = useState("");
    const [initialBrandId, setInitialBrandId] = useState(0);
    const [message, setMessage] = useState("");
    const [isHidden, setHidden] = useState(null);
    const [restoreProjectId, setRestoreProjectId] = useState(null);
    const [showRestorePopup, setShowRestorePopup] = useState(false);
    const [severity, setSeverity] = useState("");

    const handleConfirmShow = () => {
        setConfirmButtonEnable(true);
        setShoweditconfirm(true);
    }

    const handleCloseRestorePopup = () => {
        setShowRestorePopup(false);
    }

    const handleShowRestorePopup = () => {
        setShowRestorePopup(true);
    }

    function SameEntity() {
        setConfirmButtonEnable(false);
        var exactdate = null;
        let datetime = date;
        if(datetime != null && datetime != "") {
            // Generate yyyy-mm-dd date string
            exactdate = convertToDateString(datetime, "");
        }

        let data = {
            "Idprojects" : id,
            "Name" : trim(projectname),
            "EntityIds" : entityid,
            "DueDate" : exactdate,
            "ResendDate": resend.date ? convertToDateString(resend.date, "") : null,
            "Description" : trim(description),
            "ResetTasks" : false,
            "ProjectTypeId": projectTypeId,
            "AdestraReport": trim(adestraReport),
            "AdestraReportResend": trim(adestraReportResend)
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.EditProject(data, id, accesstoken,  (response) => {  
                    setConfirmButtonEnable(true);
                    if(response.status === 200) { 
                        setLoading(true); 
                        console.log("Editresponse", response);
                        handleConfirmHide();
                        setToggle(!toggle);
                        setEditerror('');
                        setOpen(false);
                    }
                    if(response.status === 400) {
                        setLoading(false);
                        setEditerror(response.data.message);
                        setOpen(true);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DifferentEntity() {
        setConfirmButtonEnable(false);
        var exactdate = null;
        let datetime = date;
        if(datetime != null && datetime != "") { 
             // Generate yyyy-mm-dd date string
             exactdate = convertToDateString(datetime, "");
        }

        let data = {
            "Idprojects" : id,
            "Name" : trim(projectname),
            "EntityIds" : entityid,
            "DueDate" : exactdate,
            "ResendDate": resend.date ? convertToDateString(resend.date, "") : null,
            "Description" : trim(description),
            "ResetTasks" : true,
            "ProjectTypeId": projectTypeId,
            "AdestraReport": trim(adestraReport),
            "AdestraReportResend": trim(adestraReportResend)
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.EditProject(data, id, accesstoken, (response) => {
                    setConfirmButtonEnable(true);
                    if(response.status == 200) {
                        console.log("Editresponse", response);
                        handleConfirmHide();
                        setToggle(!toggle);
                        setShowTasks(!showTasks); 
                    } else if(response.status === 400) {
                        setLoading(false)
                        setEditerror(response.data.message);
                        setOpen(true)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }       
                });
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function SaveProject() {  
        if(brandId == currentBrand && projectTypeId == currentprojectType) {
            SameEntity();
        } else {
            handleConfirmShow();
        }
    }

    function handledate(date) {
        setDate(date);
        setStartdate(date);
    }

    function handleResendDate(date) {
        setResend((prev) => ({ ...prev, date: date, startDate: date }));
    }

    function GetDropdown(accesstoken) {
        const endpoint = "/api/entity/dropdown";
        getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => {   
            if(response.status == 200) {
                const entityArray = [];
                response.data.data.map((task) => {
                    const entityObject = {id: 0, name: '', brandId: null}
                    entityObject.id = task["idEntities"];
                    entityObject.name = task["entityName"];
                    entityObject.propertyCode = task["entityName"].split(' -')[0]
                    entityObject.brandId = task["brandId"];
                    entityObject.parentBrand = task["parentBrand"]
                    entityArray.push(entityObject);
                })
                setEntityList(entityArray);
            } else if(response.status == 401) {
                navigate("/login")
            }   
        });
    }

    function ProjectEditNavigate() {
        // navigate(`/projects/${id}/edit`)
        setToggle(!toggle);
    }

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                GetDropdown(accesstoken);
                setOpen(false);
                const URL = `/api/Project/projectdetails/${id}`
                getResponse.GetProjectDetails(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        console.log("ProjectDetailsresponse", response.data);
                        setProjectDetails(response.data);
                        setLoading(false);

                        var breadcrumbsList = [
                            { "name": "Home", "url": "" },
                            { "name": "Projects", "url": "projects/list" },
                            { "name": `${response.data.name}`, "url": `projects/${id}/view` }
                        ];
                        dispatch(parseBreadcrumbsList(breadcrumbsList));

                        if(response.data != null) {
                            if(response.data.name != null) {
                                setProjectname(response.data.name)
                                setHidden(response.data.hidden)
                            } 
                            if(response.data.dueDate != null) {
                                const date = new Date(response.data.dueDate);
                                setDate(date);
                                setStartdate(date);
                                setLabel(convertToDateString(date, "picker"));
                            }
                            if(response.data.dueDate == null) {
                                setLabel('Select Date');
                                setDate(null);
                                setStartdate(null);
                            }

                            // Resend Date
                            if(response.data.resendDate != null) {
                                const date = new Date(response.data.resendDate);
                                setResend((prev) => ({ date: date, startDate: date, label: convertToDateString(date, "picker") }));
                            } else {
                                setResend((prev) => ({ date: null, startDate: null, label: 'Select Date' }));
                            }

                            if(response.data.entities != null) {
                                // Entity
                                var entityNameArray = [];
                                var entityPropertyCodeArray = [];
                                var entityIdArray = [];

                                for(var entity of response.data.entities) {
                                    entityNameArray.push(entity.propertyCode + " - " + entity.name);
                                    entityPropertyCodeArray.push(entity.propertyCode);
                                    entityIdArray.push(entity.idEntities);
                                }

                                setEntityName(entityNameArray.join(", "));
                                setEntityLabel(entityPropertyCodeArray.join(", "));
                                setEntityId(entityIdArray);
                                setCurrentBrand(response.data.brand.idBrand);
                                setBrandId(response.data.brand.idBrand);
                                setInitialBrandId(response.data.brand.idBrand);
                                getResponseEntity.GetEntityList('/api/entity/dropdown', accesstoken, (data) => {
                                    if (data.status == 200) {
                                        
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } 
                            if(response.data.projectType != null) {
                                setprojectTypeLabel(response.data.projectType.projectTypeName);
                                setProjectTypeId(response.data.projectType.idProjectType);
                                setCurrentProjectType(response.data.projectType.idProjectType)
                            }
                            if(response.data.description != null) {
                                setDescription(response.data.description);
                            }
                            if(response.data.adestraReport != null) {
                                setAdestraReport(response.data.adestraReport);
                            }
                            if (response.data.adestraReportResend != null) {
                                setAdestraReportResend(response.data.adestraReportResend);
                            }
                        }
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [complete, deleteform, deletefile, deletetask, uploadstate, toggle])

    const ProjectClone =  () => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const URL = `/api/Project/cloneproject/${id}`
                getResponse.ProjectClone(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        dispatch(parseCloneProject(true));
                        navigate('/projects/list?category=Active');
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    } 

    const Broadcast = () => {
        navigate(`/projects/${id}/broadcast`);
    }

    const Restore = () => {
        setRestoreProjectId(id);
        handleShowRestorePopup();
    }

    const handleEntityDropdown = (ids) => {
        setEntityId(ids);
        for(var entity of entityList) {
            if(ids.includes(entity.id)) {
                setBrandId(entity.brandId);
                break;
            }
        }
    }

    useEffect(() => {
        if(entityid != null && entityid.length > 0) {
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                }
                else {
                    getResponse.GetProjectList(`/api/brand/projecttypes?entityId=${entityid[0]}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            const templateArray = [];
                            data.data.data.map((template) => {
                                const templateObject = {id: 0, name: ''}
                                templateObject.id = template["idProjectType"];
                                templateObject.name = template["projectTypeName"];
                                templateArray.push(templateObject);
                            })
                            setProjectTypeList(templateArray);
    
                            templateArray.length > 0 ? setProjectTypeEnable(true) : resetProjectType();
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
    
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        } else {
            resetProjectType();
        }
    }, [entityid])

    const handleMouseLeave = () => {
        setTooltipMessage("Copy Link")
    }

    const resetProjectType = () => {
        setProjectTypeEnable(false);
        setProjectTypeList([]);
        setprojectTypeLabel('Select Project Type');
        setProjectTypeId(null);
    }

    const handleSnackbar = (value) => {
        if(!isHidden) {
            setOpen(value)
        }
    }
    
    useEffect(() => {
        if(isHidden != null && isHidden) {
            setOpen(true)
            setSeverity("warning")
            setMessage("This project has been deleted. Please restore it.")
        }
    }, [isHidden])

    console.log("Snackbar ", open)

    function CallRestoreApi() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.RestoreProject(restoreProjectId, accesstoken, (response) => {
                    if(response.status == 200) {
                        handleCloseRestorePopup();
                        setHidden(false)
                        setOpen(true)
                        setSeverity("success")
                        setMessage("Restored successfully");
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    return (
        <div className='project-details-container'>
            <Header />
            <div className='row details-section'>
                <Sidebar />
                <div className='col-10 details-right'>
                    <Breadcrumbs />
                    {isLoading ?
                        (<Spinner/>) : 
                        (<>
                        {toggle ?
                         (<>
                         <div className='row project-name'>
                                <div className='col-3'>
                                    <div className='heading'>
                                        Project Name
                                    </div>
                                    <div className='content'>
                                        {projectDetails && projectDetails.name}
                                    </div>
                                </div>
                                <div className={ projectDetails.resendDate != null ? 'col-2' : 'col-3'}>
                                    <div className='heading'>
                                        Due Date
                                    </div>
                                    <div className='content'>
                                        {projectDetails.dueDate != null && convertToDateString(new Date(projectDetails.dueDate), "picker")}
                                    </div>
                                </div>
                                {projectDetails.resendDate != null && <div className='col-2'>
                                    <div className='heading'>
                                        Resend Date
                                    </div>
                                    <div className='content'>
                                        {projectDetails.resendDate != null && convertToDateString(new Date(projectDetails.resendDate), "picker")}
                                    </div>
                                </div>}
                                <div className={projectDetails.resendDate != null ? 'col-2' : 'col-3'}>
                                    <div className='heading'>
                                        Property
                                    </div>
                                    <div className='content'>
                                        {entityName}
                                    </div>
                                </div>
                                <div className='col-3 actions'>
                                    {isHidden ? 
                                    <>
                                        <div className='project-restore'>
                                            <Tooltip title="Restore">
                                                <img className='restore' src={restore} alt="restore" onClick={Restore}></img>
                                            </Tooltip>                                        
                                        </div> 
                                    </> :
                                    <>
                                        <div className='project-broadcast'>
                                            <Tooltip title="Broadcast">
                                                <img className='broadcast' src={broadcast} alt="broadcast" onClick={Broadcast}></img>
                                            </Tooltip>                                        
                                        </div>
                                        <div className='project-clone'>
                                            <Tooltip title="Clone">
                                                <img className='projectclone' src={projectclone} alt="projectclone" onClick={ProjectClone}></img>
                                            </Tooltip>                                        
                                        </div>
                                        <div className='project-edit'>
                                            <Tooltip title="Edit">
                                                <img className='projecte' src={projectedit} alt="projectedit" onClick={ProjectEditNavigate}></img>
                                            </Tooltip> 
                                        </div>
                                    </>
                                    }
                                </div>
                            </div>
                            <div className='row project-type-section'>
                                <div className='col-3'>
                                    <div className='heading'>Project Id</div>
                                    <div className='content'>
                                        {projectDetails.idprojects}
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='heading'>Project Type</div>
                                    <div className='content'>
                                        {projectDetails.projectType != null && projectDetails.projectType.projectTypeName}
                                    </div>
                                </div>
                            </div>
                            <div className='row adestra-report-section'>
                                <div className={projectDetails.resendDate != null ? 'col-5' : 'col-9'}>
                                    <div className='heading'>Adestra Report</div>
                                    <div className='content'>
                                        {projectDetails.adestraReport && parse(projectDetails.adestraReport)}
                                    </div>
                                </div>
                                {projectDetails.resendDate != null && <div className='col-4'>
                                    <div className='heading'>Adestra Report (Resend)</div>
                                    <div className='content'>
                                        {projectDetails.adestraReportResend && parse(projectDetails.adestraReportResend)}
                                    </div>
                                </div>}
                            </div>
                            
                            <div className='row description-section'>
                                <div className='col-9'>
                                    <div className='heading'>Description</div>
                                    <div className='content'>
                                        {projectDetails.description &&  <Descriptor defaultdescription={ projectDetails.description } setDescription={ setDescription } readOnly={true} resize= {true} />}
                                    </div>
                                </div>
                            </div>
                            {projectDetails.brand.websiteDetails != null && 
                            <div className='row approval-links-section'>
                                <div className='col-12'>
                                    <div className='heading'>Approval Links</div>
                                    <div className='content'>
                                        <div className='approval-links'>
                                            <div className='guest-consumer' onMouseLeave={handleMouseLeave}>
                                                <div><span>Guest / Consumer: </span>
                                                    <a target="_blank" href={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-guest-consumer/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}>
                                                    {`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-guest-consumer/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    </a>
                                                </div>
                                                <CopyToClipboard
                                                    text={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-guest-consumer/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                    <span>
                                                        <Tooltip title={tooltipMessage}>
                                                            <div className='icon icon-copy icon-2x'></div>
                                                        </Tooltip> 
                                                    </span>
                                                </CopyToClipboard>                                       
                                            </div>
                                            <div className='event-planner' onMouseLeave={handleMouseLeave}>
                                                <div><span>Event Planner / Group: </span>
                                                    <a target="_blank" href={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/${projectDetails.brand.name.toLowerCase().includes('hilton') ? "approve-event-planner-group" : "approve-group-events"}/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}>
                                                        {`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/${projectDetails.brand.name.toLowerCase().includes('hilton') ? "approve-event-planner-group" : "approve-group-events"}/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    </a>
                                                    </div>
                                                <CopyToClipboard
                                                    text={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/${projectDetails.brand.name.toLowerCase().includes('hilton') ? "approve-event-planner-group" : "approve-group-events"}/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                    <span>
                                                        <Tooltip title={tooltipMessage}>
                                                            <div className='icon icon-copy icon-2x'></div>
                                                        </Tooltip> 
                                                    </span>
                                                </CopyToClipboard>  
                                            </div>
                                            <div className='gem' onMouseLeave={handleMouseLeave}>
                                                <div><span>gEM: </span>
                                                    <a target="_blank" href={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-gem/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}>
                                                    {`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-gem/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    </a>
                                                </div>
                                                <CopyToClipboard
                                                    text={`${process.env.REACT_APP_PROTOCOL}://${projectDetails.brand.websiteDetails.siteUrl}/approve-gem/${encodeURIComponent(projectDetails.name)}/${projectDetails.idprojects}${projectDetails.projectIdHash != null ? "?signature="+projectDetails.projectIdHash : ""}`}
                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                    <span>
                                                        <Tooltip title={tooltipMessage}>
                                                            <div className='icon icon-copy icon-2x'></div>
                                                        </Tooltip> 
                                                    </span>
                                                </CopyToClipboard>                                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {projectDetails.broadcasts != null && projectDetails.broadcasts.length > 0 && projectDetails.broadcasts[0].status == "Published" &&
                            <div className='row approval-links-section'>
                                <div className='col-12'>
                                    <div className='heading'>Email Broadcast</div>
                                    <div className='content'>
                                        <div className='approval-links'>
                                            {/* <div className='guest-consumer' onMouseLeave={handleMouseLeave}>
                                                <div><span>Draft Link: </span>
                                                    <a target="_blank" href={process.env.REACT_APP_CC_BASE_URL+"/broadcast/draft/"+projectDetails.name.toLowerCase().replace(' ', '')+"/"+projectDetails.broadcasts[0].idBroadcast}>
                                                        {process.env.REACT_APP_CC_BASE_URL+"/broadcast/draft/"+projectDetails.name.toLowerCase().replace(' ', '')+"/"+projectDetails.broadcasts[0].idBroadcast}
                                                    </a>
                                                </div>
                                                <CopyToClipboard
                                                    text={process.env.REACT_APP_CC_BASE_URL+"/broadcast/draft/"+projectDetails.name.toLowerCase().replace(' ', '')+"/"+projectDetails.broadcasts[0].idBroadcast}
                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                    <span>
                                                        <Tooltip title={tooltipMessage}>
                                                            <div className='icon icon-copy icon-2x'></div>
                                                        </Tooltip> 
                                                    </span>
                                                </CopyToClipboard>                                       
                                            </div> */}
                                            {projectDetails.broadcasts[0].status == "Published" && 
                                            <div className='event-planner' onMouseLeave={handleMouseLeave}>
                                                <div><span>Draft Link: </span>
                                                    <a target="_blank" href={process.env.REACT_APP_CC_BASE_URL+"/broadcast/"+((projectDetails.brand.parentBrandName && projectDetails.brand.parentBrandName.toLowerCase().replaceAll(' ', '-')) || projectDetails.brand.name.toLowerCase().replaceAll(' ', '-'))+"/"+projectDetails.idprojects+"/"+projectDetails.name.toLowerCase().replaceAll(' ', '-')+"/"+projectDetails.broadcasts[0].idBroadcast}>
                                                    {process.env.REACT_APP_CC_BASE_URL+"/broadcast/"+((projectDetails.brand.parentBrandName && projectDetails.brand.parentBrandName.toLowerCase().replaceAll(' ', '-')) || projectDetails.brand.name.toLowerCase().replaceAll(' ', '-'))+"/"+projectDetails.idprojects+"/"+projectDetails.name.toLowerCase().replaceAll(' ', '-')+"/"+projectDetails.broadcasts[0].idBroadcast}
                                                    </a>
                                                    </div>
                                                <CopyToClipboard
                                                    text={process.env.REACT_APP_CC_BASE_URL+"/broadcast/"+((projectDetails.brand.parentBrandName && projectDetails.brand.parentBrandName.toLowerCase().replaceAll(' ', '-')) || projectDetails.brand.name.toLowerCase().replaceAll(' ', '-'))+"/"+projectDetails.idprojects+"/"+projectDetails.name.toLowerCase().replaceAll(' ', '-')+"/"+projectDetails.broadcasts[0].idBroadcast}
                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                    <span>
                                                        <Tooltip title={tooltipMessage}>
                                                            <div className='icon icon-copy icon-2x'></div>
                                                        </Tooltip> 
                                                    </span>
                                                </CopyToClipboard>  
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            </>) : 
                            (<div className='edit-project-content'>
                                <div className='save' onClick={() => SaveProject(id)}>Save</div>
                                <div className='row label-input-row'>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label className='required'>Project Name</label>
                                            <div className='input-box'> 
                                                <input id="projectname" type="text" value={ projectname } onChange={(e) => setProjectname(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${projectDetails.resendDate != null ? 'col-2' : 'col-4' } label-input-col`}>
                                        <div className='label-input label-input-due'>
                                            <label className='required'>Due Date</label>
                                            {(projectDetails.dueDate || projectDetails.dueDate == null || projectDetails.dueDate == '') &&
                                                <Calender minDate={false} maxDate={false} startdate={startdate} 
                                                HandleDate={(date) => handledate(date)} 
                                                HandleLabel={(date) => setLabel(convertToDateString(date, "picker"))} 
                                                label={label}
                                                disablefromto={false} disableto={false}
                                                />
                                            }
                                        </div>
                                    </div>
                                    {projectDetails.resendDate != null && <div className='col-2 label-input-col'>
                                        <div className='label-input label-input-due'>
                                            <label className='required'>Resend Date</label>
                                            {(projectDetails.resendDate || projectDetails.resendDate == null || projectDetails.resendDate == '') &&
                                                <Calender minDate={false} maxDate={false} startdate={resend.startDate} 
                                                HandleDate={(date) => handleResendDate(date)} 
                                                HandleLabel={(date) => setResend(prev => ({ ...prev, label: convertToDateString(date, "picker") }))} 
                                                label={resend.label}
                                                disablefromto={false} disableto={false}
                                                />
                                            }
                                        </div>
                                    </div>}
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-entity'>
                                            <label className='required'>Property</label>
                                            {
                                                <MultiSelectionDropdown label={entityLabel} selectedItem={(ids) => handleEntityDropdown(ids)}
                                                    handleLabel={(value) => setEntityLabel(value)} list={entityList} 
                                                    selectedBrand={initialBrandId}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='row project-type-row'>
                                    <div className='col-4 label-input-col'>
                                        <div className={projectTypeEnable ? 'label-input label-input-entity pointer-all' : 'label-input label-input-entity pointer-none'}>
                                            <label className={projectTypeEnable ? '' : 'dropdown-grey'}>Project Type</label>
                                            <Dropdown label={projectTypeLabel} selectedItem={(name, id) => setProjectTypeId(id)}
                                                handleLabel={(value) => setprojectTypeLabel(value)} list={projectTypeList} enable={projectTypeEnable}/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row report-input-row'>
                                    <div className={`${projectDetails.resendDate != null ? 'col-6' : 'col-12'} label-input-col report-input`}>
                                        <div className='label-input label-input-name'>
                                            <label>Adestra Report</label>
                                            <div className='input-box'> 
                                                <input type="text" value={adestraReport ? adestraReport : ''} onChange={(e) => setAdestraReport(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>
                                   {projectDetails.resendDate != null && <div className='col-6 label-input-col report-input'>
                                        <div className='label-input label-input-name'>
                                            <label>Adestra Report (Resend)</label>
                                            <div className='input-box'> 
                                                <input type="text" value={adestraReportResend ? adestraReportResend : ''} onChange={(e) => setAdestraReportResend(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                <div className='row description-row'>
                                    <div className='col-12'>
                                        <label>Description</label>
                                        { 
                                            <Descriptor defaultdescription={ projectDetails.description && projectDetails.description } setDescription={ setDescription } />
                                        }
                                    </div>
                                </div>
                            </div>)
                        }
                        {
                            projectDetails && projectDetails.tasksClxes &&
                            <ProjectInfo 
                                fivetasks={ projectDetails.tasksClxes } fivefiles={ projectDetails.filesClxes} completecount = {projectDetails.completedTasks}
                                fiveforms={ projectDetails.formSubmissions} setComplete={setComplete} complete={complete}
                                setDeleteForm={ setDeleteForm } deleteform={ deleteform } setDeleteFile={ setDeleteFile } deletefile={ deletefile }
                                setDeleteTask={ setDeleteTask } deletetask={ deletetask } setUpload={ setUpload } uploadstate={ uploadstate } showTasks={showTasks} showTask={false}
                                isHidden={isHidden}
                            />
                        }
                    </>)}
                </div>
            </div>
            <Snackbars error={editerror} open={open} setOpen={(value) => handleSnackbar(value)}/>
            {(isHidden || restoreProjectId) && <Snackbars error="" open={open} setOpen={(value) => handleSnackbar(value)} severity={severity} message={message}/>}
            <EditProjectConfirm showeditconfirm={showeditconfirm} handleConfirmHide={handleConfirmHide}  DifferentEntity={DifferentEntity} SameEntity={SameEntity} projectname={projectname}
            enable={confirmButtonEnable}/>
            {/* Showing restore popup */}
            <DeleteItem show={showRestorePopup} handleClose={handleCloseRestorePopup} deleteApiCall={CallRestoreApi} 
            enable={true} type="restore"/>
            <Footer />    
        </div>
    );
}

export default PageDetails;